import { useMemo } from 'react'
import useOffer from 'hooks/Offers/useOffer'
import { getPackageUniqueKey } from 'lib/offer/offerUtils'
import { isMultiCartHotelItem } from 'components/Pages/UserCartPage/SharedCarts/multiCartUtils'
import { isBedbankOffer } from 'lib/offer/offerTypes'
import type { CartPanelAccommodationItem } from './useCartPanelItems'

export type CartPanelHotelOffer = App.HotelOffer | App.BedbankOffer

function useCartPanelHotelOfferData(item: CartPanelAccommodationItem) {
  const [offer, loading] = useOffer<CartPanelHotelOffer>(item.offerId)

  const cartHotelItem = item.cartItem && isMultiCartHotelItem(item.cartItem) ? item.cartItem : undefined

  const pkg = useMemo(() => {
    if (!offer) return undefined

    if (isBedbankOffer(offer)) {
      return offer.packages.find(p => p.roomId === item.packageId)
    }

    if (!cartHotelItem?.packageId || !cartHotelItem?.roomRateId) return undefined
    const duration = item.duration ?? cartHotelItem.duration
    const uniqueKey = getPackageUniqueKey(cartHotelItem.packageId, duration, cartHotelItem.roomRateId)
    return offer.packages.find(p => p.uniqueKey === uniqueKey)
  }, [offer, cartHotelItem, item.duration, item.packageId])

  return {
    offer,
    pkg,
    loading,
    checkIn: cartHotelItem?.checkIn,
    checkOut: cartHotelItem?.checkOut,
  }
}

export default useCartPanelHotelOfferData
